import { render, staticRenderFns } from "./ticket-sla-form.vue?vue&type=template&id=4679f591"
import script from "./ticket-sla-form.vue?vue&type=script&lang=js"
export * from "./ticket-sla-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports